<template>
  <li class="summary-section-185cd">
    <div v-if="props.summarySection.page || props.summarySection.creator" class="summary-section-185cd__community-n-creator-side">
      <!-- Title & logo snippet -->
      <RouterLink
        v-if="props.isPageAvatarVisible && props.summarySection.page"
        :to="{
          name: 'Pages',
          params: {
            pageId: props.summarySection.page?.id,
          },
        }"
        class="title-n-logo-snippet-f85d1 summary-section-185cd__community-snippet"
      >
        <!--<div class="global-h2 title-n-logo-snippet-f85d1__title">&lt;!&ndash;{{ props.summarySection.page?.title }}&ndash;&gt;&nbsp;</div>-->
        <div class="title-n-logo-snippet-f85d1__logo-wrap">
          <img
            class="title-n-logo-snippet-f85d1__logo title-n-logo-snippet-f85d1__logo--bigger"
            :src="`${contentBaseUri}/cms/images/orgs/${props.summarySection.page?.icon}`"
            :alt="props.summarySection.page?.title"
          />
        </div>
      </RouterLink>
      <!-- / Title & logo snippet -->

      <IconEmbedded v-if="props.isPageAvatarVisible && props.isCreatorAvatarVisible" class="summary-section-185cd__plus-sign" name="plus_3" :size="66" />

      <!-- Title & logo snippet -->
      <RouterLink
        v-if="props.isCreatorAvatarVisible && props.summarySection.creator"
        :to="{
          name: 'CreatorProfilePublic',
          params: {
            creatorId: props.summarySection.creator?.uriKey,
          },
        }"
        class="title-n-logo-snippet-f85d1 summary-section-185cd__creator-snippet"
      >
        <div class="global-h2 title-n-logo-snippet-f85d1__title">{{ props.summarySection.creator?.firstName }}</div>
        <div class="title-n-logo-snippet-f85d1__logo-wrap">
          <CreatorAvatar class="title-n-logo-snippet-f85d1__logo" :imageUri="props.summarySection.creator?.profileImageUri" :isWithPlusIcon="props.summarySection.creator?.isCollabEligible" />
        </div>
      </RouterLink>
      <!-- / Title & logo snippet -->
    </div>

    <div class="summary-section-185cd__itineraries-side">
      <div class="global-h2 summary-section-185cd__itineraries-title">
        <RouterLink
          :to="{
            name: 'CollabSummaryPublic',
            params: {
              communityId: props.summarySection.page?.id,
              collabInputId: props.summarySection.collabDetails.collabInputId,
            },
          }"
        >
          {{ props.summarySection.collabDetails.collabName }}
        </RouterLink>

        <div v-if="props.isVisitDateVisible && props.summarySection.collabDetails.visitDate" class="summary-section-185cd__itineraries-title-date">
          {{ DateUtils.formatDateRange(props.summarySection.collabDetails.visitDate, 0, true, "MMM YYYY") }}
        </div>
      </div>

      <HighlightsSection
        v-if="props.summarySection.collabDetails?.highlightAssetIds?.length"
        class="summary-section-185cd__highlights-section"
        :highlightAssetIds="props.summarySection.collabDetails?.highlightAssetIds"
      />

      <ul v-else class="summary-section-185cd__itineraries-list">
        <ItineraryTile
          class="summary-section-185cd__itinerary"
          v-for="itinerary in props.summarySection.itineraries.slice(0, 4)"
          :itinerary="itinerary"
          :key="itinerary.id"
          :allowShortImage="false"
          :source="null"
        />
      </ul>

      <div v-if="props.summarySection.collabDetails?.locationCount > 0 || props.summarySection.collabDetails?.photoCount > 0" class="summary-section-185cd__stats-section">
        <!-- Stats cell -->
        <div class="stats-cell-a4e8f summary-section-185cd__stats-cell">
          <div class="stats-cell-a4e8f__number">{{ props.summarySection.collabDetails?.locationCount }}</div>
          <div class="stats-cell-a4e8f__text">Locations</div>
        </div>
        <!-- / Stats cell -->

        <!-- Stats cell -->
        <div class="stats-cell-a4e8f summary-section-185cd__stats-cell">
          <div class="stats-cell-a4e8f__number">{{ props.summarySection.collabDetails?.photoCount }}</div>
          <div class="stats-cell-a4e8f__text">Photos</div>
        </div>
        <!-- / Stats cell -->

        <!-- Stats cell -->
        <div v-if="props.summarySection.collabDetails?.videoCount > 1" class="stats-cell-a4e8f summary-section-185cd__stats-cell">
          <div class="stats-cell-a4e8f__number">{{ props.summarySection.collabDetails?.videoCount }}</div>
          <div class="stats-cell-a4e8f__text">Videos</div>
        </div>
        <!-- / Stats cell -->
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import { onBeforeMount } from "vue";

// Components
import CreatorAvatar from "@components/CreatorAvatar.vue";
import HighlightsSection from "@components/HighlightsSection.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import ItineraryTile from "@components/ItineraryTile.vue";

// Types
import { CollabSummaryModel } from "@contracts/collabCredits";
import DateUtils from "@logic/DateUtils";

// Global variables
const contentBaseUri = globalThis.Bootstrap.Config.contentCdnBaseUri;

// CSS
onBeforeMount(async () => await import("./CollabSummarySection.vue.scss"));

const props = withDefaults(
  defineProps<{
    summarySection: CollabSummaryModel;
    isVisitDateVisible?: boolean;
    isPageAvatarVisible?: boolean;
    isCreatorAvatarVisible?: boolean;
  }>(),
  {
    summarySection: null,
    isVisitDateVisible: true,
    isPageAvatarVisible: true,
    isCreatorAvatarVisible: true,
  }
);
</script>
